module.exports = {
  /**
   * @type { string }
   * @description 项目名称
   */
  title: '项目名称',
};
